import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import StudentAssignmentForm from 'components/organisms/forms/StudentAssignmentForm'

import { crudActionsMap } from 'utils/helpers'

const StudentAssignmentCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view'
  return (
    <>
      <PageHeading title={`${t('common.assignment')} / ${t('common.' + action)}`} />
      <PageBody>
        <StudentAssignmentForm action={action} id={id} />
      </PageBody>
    </>
  )
}
export default StudentAssignmentCrudPage
